<template>
    <v-menu class="dot-menu" :close-on-content-click="false" v-model="openMenu" left offset-x nudge-top="100">
        <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="getAuthItem" style="height: 36px !important;">
                <v-icon>mdi-dots-horizontal</v-icon>
            </v-btn>
        </template>
        <v-list v-if="edit || editTeam">
            
            <!-- キャビネットが対象でグループ管理権限ある場合 or フォルダが対象で編集権限がある場合 -->
            <v-list-item link @click="clickRename" v-if="(cabinet && editTeam) || (!cabinet && folder && edit)">
                <v-list-item-title><v-icon left>mdi-pencil</v-icon>名前変更</v-list-item-title>
            </v-list-item>
            
            <!-- フォルダまたは契約が対象で管理権限がある場合（検索結果画面、初期状態＝すべての書類が表示されている画面を除く） -->
            <v-list-item link @click="clickMove" v-if="!cabinet && edit && !searchResult && !currentFolderIsAllDocCabinet">
                <v-list-item-title class="context-move"><v-icon left>mdi-content-save-move</v-icon>移動</v-list-item-title>
            </v-list-item>
            
            <v-list-item link @click="clickDeleteImportFile" v-if="!cabinet && importFile && edit && !searchResult">
                <v-list-item-title><v-icon left>mdi-delete</v-icon>書類の削除</v-list-item-title>
            </v-list-item>
            
            <!-- キャビネットが対象でグループ管理権限がある場合 or フォルダーか契約が対象で管理権限がある場合（検索結果画面、初期状態＝すべての書類が表示されている画面を除く） -->
            <v-list-item link @click="clickDelete" v-if="!currentFolderIsAllDocCabinet && !searchResult && ((cabinet && editTeam) || (!cabinet && edit))">
                <v-list-item-title class="context-delete"><v-icon left>mdi-delete</v-icon>{{ (cabinet || folder) ? "削除" : "キャビネットから削除" }}</v-list-item-title>
            </v-list-item>
            
            <!-- 契約が対象で管理権限がある場合 -->
            <v-list-group
                    v-model="openList"
                    no-action
                    v-if="(!cabinet && !folder) && edit"
                  >
                <template v-slot:activator>
                    <v-list-item-title class="context-share"><v-icon left>mdi-share-variant</v-icon>キャビネット</v-list-item-title>
                </template>
                <v-list-item link @click="clickShare">
                    <v-list-item-title class="context-share"><v-icon left>mdi-plus</v-icon>共有登録</v-list-item-title>
                </v-list-item>
                <v-list-item link @click="clickDeleteShare">
                    <v-list-item-title class="context-delete"><v-icon left>mdi-minus</v-icon>共有削除</v-list-item-title>
                </v-list-item>  
            </v-list-group>
            
            <!-- 対象がキャビネットでグループ管理権限がある場合 -->
            <v-list-item link @click="clickEditMemberGroup" v-if="cabinet && editTeam">
                <v-list-item-title class="context-menber-group"><v-icon left>mdi-account-multiple-plus</v-icon>グループの編集</v-list-item-title>
            </v-list-item>
        </v-list>
        
        <!-- v-elseだと権限取得前に一瞬表示されてしまうため、取得後に表示されるように専用のフラグ（noAuth）を設けた -->
        <v-list v-if="noAuth">
            <v-list-item>
                <v-list-item-title class="context-delete">権限がありません</v-list-item-title>
            </v-list-item>
        </v-list>
        
        <!-- 読込中 -->
        <v-list v-if="loading">
            <v-list-item>
                <v-list-item-title class="context-loading">
                    <!-- 初期位置調整用空白　変数に代入すると文字列で出力されるので直接書くもっといい方法があったら変えたい-->
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;読込中...&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>
<script>
export default {
    data() {
        return {
            loading: true,
            openList: false,
            openMenu: false,
            // 編集可否
            edit: false,
            // グループ編集可否
            editTeam: false,
            // 権限なし
            noAuth: false,
            // キャビネット作成元ID
            cabinetOwnerId: null,
        }
    },
    props: {
        // 現在の階層が、すべての書類かどうか
        currentFolderIsAllDocCabinet: {
            default: false,
        },
        // キャビネットかどうか
        cabinet: {
            default: 0,
        },
        // フォルダかどうか
        folder: {
            default: 0,
        },
        // 契約またはキャビネットのID
        agreementsOrFoldersId: {
            type: Number,
        },
        // 検索結果か
        searchResult: {
            type: Boolean,
            type: false,
        },
        // インポートファイルかどうか
        importFile: {
            type: Boolean,
            type: false,            
        }
    },
    methods: {
        // 項目の権限取得
        getAuthItem() {
            axios.get('/documents/document-management/get-item-auth',{
                params: {
                    current_folder_is_all_doc_cabinet: this.currentFolderIsAllDocCabinet,
                    is_cabinet: this.cabinet,
                    is_folder: this.folder,
                    id: this.agreementsOrFoldersId,
                }
            }).then(res => {
                this.edit = res.data.is_edit;
                this.editTeam = res.data.is_editTeam;
                
                ////  以下のいずれかのときは権限が存在しないと認識 ////
                // 編集もグループ編集も行えない
                // 契約が対象で編集が行えない
                // キャビネットが対象でグループ権限が存在しない
                this.noAuth = (!res.data.is_edit && !res.data.is_editTeam)
                    || (!res.data.is_edit && (!this.cabinet & !this.folder))
                    || (!res.data.is_editTeam && this.cabinet);
                    
                this.cabinetOwnerId = res.data.cabinet_owner_id;
            }).finally(() => {
                this.loading = false;
            });
        },
        clickDelete() {
            this.openMenu = false;
            this.openList = false;
            this.$emit('clickDelete');
        },
        clickRename() {
            this.openMenu = false;
            this.openList = false;
            this.$emit('clickRename');
        },
        clickShare() {
            this.openMenu = false;
            this.openList = false;
            this.$emit('clickShare');
        },
        clickDeleteShare() {
            this.openMenu = false;
            this.openList = false;
            this.$emit('clickDeleteShare');
        },
        clickMove() {
            this.openMenu = false;
            this.openList = false;
            this.$emit('clickMove');
        },
        clickEditMemberGroup() {
            this.openMenu = false;
            this.openList = false;
            this.$emit('clickEditMemberGroup', this.cabinetOwnerId);
        },
        clickDeleteImportFile() {
            this.openMenu = false;
            this.openList = false;
            this.$emit('clickDeleteImportFile');
        }
    },
};
</script>

<style scoped>
    .context-delete {
        color: red;
    }
    .context-share {
        color: blue;
    }
    .context-menber-group,.context-loading {
        color: green;
    }
    .dot-menu {
        z-index: 100;
    }
</style>